<div class="loginform">
  <div class="loginErrorMessage loginerroMessa d-flex" *ngIf="loginErrorMessage">
    <div class="me-2">
      <img [src]="'IMAGES.ERRORIMG'|translate" alt="" />
    </div>
    <div>
      <div class="textColor">{{ loginErrorMessage | translate}}</div>
      <div class="validaTextCOlor" *ngIf="!isLockErrMsg">{{
        "LOGIN.VALIDEMAILORPASSWORD" | translate
        }}</div>
    </div>
  </div>
  <div class="login-logo mx-auto my-2">
    <!-- <img [src]="'SIDEBAR.Q-LOGO2'  | translate" width="55" height="55" alt="Logo"> -->
  </div>
  <div *ngIf="signIn" class="d-flex align-items-center justify-content-end mb-5 ms-auto">
    <label class="font-14">{{ "LOGIN.SELECTLANGSTR" | translate }}</label>
    <select class="form-select w-auto ms-2" [(ngModel)]="selectedLanguage"
      (ngModelChange)="onLanguageSelectionChange($event)">
      <option *ngFor="let language of dropdownLanguages" [ngValue]="language.value">
        {{ language.name }}
      </option>
    </select>
  </div>
  <!-- <h1 class="mt-3 mb-3 text-center"> -->
  <strong style="position:relative; bottom:0.5rem; font-size: 1.6rem; text-align: left;"> {{ "LOGIN.TITLE" | translate
    }}</strong>
  <!-- </h1> -->
  <ng-container *ngIf="signIn" #signIn>
    <app-loader *ngIf="isLoading"></app-loader>
    <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
      <div class="">
        <label for="mblNumoremail" class="q-form-label">{{ "LOGIN.MOBILENUMBEREMAIL" | translate }}
          <span class="text-danger">*</span>
        </label>
        <input required type="text" id="username" autofocus [minlength]="minLength" [maxlength]="maxLength"
          autocomplete="off" (keypress)="removeSpace($event)" (keyup)="checkInput($event)"
          class="form-control q-form-control" formControlName="userName" [ngClass]="{
          'is-invalid': isSubmitted && f['userName'].errors
        }" placeholder="{{ 'LOGIN.ENTERMOBILENUMBEREMAIL' | translate }}" #usernameTempRef />
      </div>

      <div class="mt-4 relative">
        <label for="password" class="q-form-label">{{ "LOGIN.PASSWORD" | translate }}
        </label>
        <span class="text-danger">*</span>
        <input required [type]="password" id="password" [minlength]=" minLength" [maxlength]="maxLength"
          (keypress)="removePasswordSpace($event)" autocomplete="off" class="form-control q-form-control pr-40"
          placeholder="{{ 'LOGIN.ENTERYOURPASSWORD' | translate }}" formControlName="password"
          [ngClass]="{ 'is-invalid': isSubmitted && f['password'].errors }" />
        <div class="showpwdIcon" (click)="onClick('loginPwd')">
          <img [src]="'IMAGES.HIDEPWD'|translate" alt="" *ngIf="!loginPassword && f['password'].value?.length != 0"
            class="cursor-pointer" />
          <img [src]="'IMAGES.SHOWPWD'|translate" alt="" *ngIf="loginPassword && f['password'].value?.length != 0"
            class="cursor-pointer" />
        </div>
      </div>
      <ng-container *ngIf="
        isSubmitted && f['password'].errors && f['password'].value?.length === 0
      ">
      </ng-container>

      <div class="forgot-pwd cursor-pointer">
        <span data-bs-toggle="modal" (click)="openForgotPassword()">{{
          "LOGIN.FORGOTPASSWORD" | translate
          }}</span>
      </div>

      <ng-container *ngIf="showCaptcha">
        <ngx-recaptcha2 #captchaElem siteKey="6LcMjEwhAAAAAE2vVJmSbwo8S4lqZithppOd-qlO" formControlName="captchaToken">
        </ngx-recaptcha2>
      </ng-container>
      <div>
        <button type="submit" [disabled]="this.loginForm.controls['userName'].value==null || this.loginForm.controls['userName'].value== ''|| 
        this.loginForm.controls['password'].value==null || this.loginForm.controls['password'].value == ''" [ngClass]="this.loginForm.controls['userName'].value==null || this.loginForm.controls['userName'].value== ''|| 
        this.loginForm.controls['password'].value==null || this.loginForm.controls['password'].value == ''? 'q-invalid-button m-2rem'
        : 'submit-btn bg-orgclr m-2rem w-100'" (click)="sendMessageToFlutter()">
          {{ "LOGIN.SIGNIN" | translate }}
        </button>
      </div>
    </form>

    <div class="d-flex align-items-center">
      <div class="line"></div>
      <div class="or-text" data-toggle="tooltip" i18n-title title="{{ 'LOGIN.ORCONTINUEWITH'| translate }}"
        [ngStyle]="{'white-space': selectedLanguage === 'ITALIAN' ? 'nowrap' : 'unset'}">
        {{"LOGIN.ORCONTINUEWITH"| translate }}</div>
      <div class="line"></div>
    </div>

    <div class="text-center mt-4">
      <div class="d-flex align-items-center justify-content-evenly">
        <div class="q-icon-box cursor-pointer" (click)="loginWithGoogle()">
          <img [src]="'IMAGES.GOOGLEIMG'|translate" alt="google" />
        </div>
        <!-- <div class="q-icon-box cursor-pointer" (click)="loginWithFacebooK()">
          <img [src]="'IMAGES.FACEBOOKIMG'|translate" alt="facebook" />
        </div> -->
      </div>
    </div>



    <div class="text-center mt-4" *ngIf="deviceInfo.deviceType=='mobile'&& platform=='WebView'">

      <div class="d-flex align-items-center justify-content-evenly">
        <div class="q-icon-box cursor-pointer" (click)=" openPopup()">
          <img [src]="'IMAGES.GOOGLEIMG'|translate" alt="google" />
        </div>

      </div>

    </div>
    <div class="d-flex align-items-center justify-content-center mt-4">
      <div class="me-2 dontHaveAc" data-toggle="tooltip" i18n-title title='{{ "LOGIN.DONTHAVEACCOUNT" | translate }}'>{{
        "LOGIN.DONTHAVEACCOUNT" | translate }}</div>
      <div class="signuptxt cursor-pointer" data-toggle="tooltip" i18n-title title='{{ "LOGIN.SIGNUP" | translate }}'
        (click)="goToSignUp(true)">
        {{ "LOGIN.SIGNUP" | translate }}
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!signIn" #signIn>
    <div class="login-otp">
      <h5 class="mb-2 text-start">
        <app-main-heading>
          <span title> {{"LOGIN.ENTEROTP" | translate }}</span>
        </app-main-heading>
      </h5>
      <small>{{"LOGIN.SENTON" | translate }} <strong class="textColorGreenVogue">{{emailId}}</strong></small>
      <div class="mt-4">
        <span class="">
          <strong>{{"LOGIN.OTP" | translate }}</strong><small class="text-danger">*</small>
        </span>
      </div>
      <div class="form-div">
        <div class="form-group">
          <div class="d-flex justify-content-center align-items-center mt-1 mb-2">
            <div>
              <div class="charClass me-2">
                {{ otpText }}
              </div>
            </div>
            <div>
              <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="{ length: 4, allowNumbersOnly: true }"
                #ngOtpInput>
              </ng-otp-input>
            </div>
          </div>
          <div *ngIf="submitOtpErrorMessage">
            <p class="errMessage pt-3">
              {{ submitOtpErrorMessage }}
            </p>
          </div>
        </div>
        <div class="btn-div mt-5 mb-3">
          <button type="button" class="submit-btn bg-orgclr mb-3"
            [ngClass]="otpValue.length!=4 ?'q-invalid-button mb-3':'submit-btn bg-orgclr mb-3'"
            [disabled]="otpValue.length!=4 " (click)="logIn()">
            {{ "LOGIN.SUBMITOTP" | translate }}
          </button>
        </div>
        <div class="d-flex align-items-center justify-content-center mb-3 notOtpDiv" *ngIf="!timeOver && isOTP">
          <span>{{ "LOGIN.DIDNTRECEIVEOTP" | translate }}</span>
          <button type="button" class="border-0 bg-white resend-Otp cursor-pointer shadow-none outline-none p-0 ms-2"
            (click)="resendLoginOtp()">
            <u>{{ "LOGIN.RESEND" | translate }}</u>
          </button>
        </div>
      </div>
      <ng-container *ngIf="timeOver">
        <div class="d-flex align-items-center justify-content-center mb-3">
          <small>
            {{ "RESENDOT.RESENDOTPIN" | translate }}
            {{ durationMinutes }}</small>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>

<div class="modal" id="floatingWindowPopup" data-bs-backdrop="static">
  <div class="modal-dialog modal-dialog-centered ">
    <ng-container>
      <div
        class="modal-content text-center border-none changeWidthHeight rounded-25 shadow-lg relative w-100 pointer-events-auto bg-white outline-none">

        <h5 class="fw-bold mt-3 mb-2">
          {{ "MANAGEDEVICE.METAPROTECT" | translate }}
        </h5>
        <p class="text-sm p-xl-2">
          {{ "MANAGEDEVICE.METAPROTECT1" | translate }}
        </p>
        <p class="text-sm p-xl-2">
          {{ "MANAGEDEVICE.METAPROTECT2" | translate }}
        </p>
        <p class="text-sm p-xl-2">
          {{ "MANAGEDEVICE.METAPROTECT3" | translate }}
        </p>
      </div>
    </ng-container>

  </div>
</div>
<div class="modal" id="forgotpwd" data-bs-backdrop="static" [class.spanish-layout]="isSpanish">
  <app-loader *ngIf="isLoading"></app-loader>
  <div class="modal-dialog modal-dialog-centered">
    <ng-container *ngIf="isMobile">
      <div class="modal-content forgotpwd p-4">
        <!-- Modal Header -->
        <div class="text-center mb-3">
          <h5 class="mb-0">
            <app-main-heading>
              <span title>{{ "LOGIN.FORGOTPASSWORDPOPUP" | translate }}</span>
            </app-main-heading>
          </h5>
        </div>
        <!-- Modal body -->
        <form [formGroup]="forgotPwdEmailForm" (ngSubmit)="emailOTP()">
          <div class="">
            <div class="form-div ">
              <label for="mblNumoremail" class="q-form-label">

                {{ "LOGIN.MOBILENUMBEREMAIL" | translate }}
                <span class="required">
                  *
                  <span class="dashboard-tooltip">
                    <img src="assets/images/Group 1000007342dashboardinfoicon.svg" class="info-icon" alt="" />
                    <span class="dropdown-content">
                      {{ "LOGIN.TOOLTIPFORGOTPASS" | translate }}
                    </span>
                  </span>
                </span>

              </label>



              <input type="text" id="username" autofocus [minlength]="minLength" [maxlength]="maxLength"
                autocomplete="off" (keypress)="removeSpace($event)" (keyup)="checkInput($event)"
                class="form-control q-form-control" formControlName="userName" [ngClass]="{
                  'is-invalid': isSubmitted && f['userName'].errors
                }" placeholder="{{ 'LOGIN.ENTERMOBILENUMBEREMAIL' | translate }}" #usernameTempRef />
              <ng-container *ngIf="forgotPasswordErrorMessage">
                <p class="errMessage">
                  {{ forgotPasswordErrorMessage }}
                </p>
              </ng-container>
              <ng-container *ngIf="loginForgotErrorMessage">
                <p class="errMessage">{{loginForgotErrorMessage}}</p>
              </ng-container>
            </div>

            <div class="btn-div mt-3">
              <ngx-recaptcha2 #captchaElem siteKey="6LcMjEwhAAAAAE2vVJmSbwo8S4lqZithppOd-qlO"
                formControlName="captchaToken">
              </ngx-recaptcha2>
            </div>
            <div class="btn-div mt-3">
              <div class="">
                <button type="submit" class="submit-btn bg-orgclr mb-3" [disabled]="forgotPwdEmailForm.invalid"
                  [ngClass]="
                forgotPwdEmailForm.invalid
                  ? 'q-invalid-button'
                  : 'submit-btn bg-orgclr'
              ">
                  {{ "LOGIN.SUBMIT" | translate }}
                </button>
              </div>
              <div class="mb-3">
                <button type="button" class="cancel-btn bg-cancelbtn" (click)="closeForgotPopModal()">
                  {{ "LOGIN.CANCEL" | translate }}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </ng-container>
    <ng-container *ngIf="isOTP">
      <div class="modal-content enterotp p-4">
        <div class="text-center">
          <h5 class="mb-0">
            <app-main-heading>
              <span title> {{ "LOGIN.ENTEROTP" | translate }}</span>
            </app-main-heading>
          </h5>
          <small>{{ "LOGIN.SENTON" | translate }} {{ sentEmail }}</small>
        </div>
        <!-- Modal body -->
        <div class="form-div">
          <div class="mt-4 form-group">
            <div class="d-flex justify-content-center align-items-center mt-1 mb-2">
              <span>
                <div class="charClass me-2 me-md-3">
                  {{ emailResponse }}
                </div>
              </span>
              <ng-otp-input (onInputChange)="onOtpChange($event)" #ngOtpInput
                [config]="{ length: 4, allowNumbersOnly: true }">
              </ng-otp-input>
            </div>
            <div *ngIf="submitOtpErrorMessage">
              <p class="errMessage" [ngClass]='!language || language == "en" ? "text-left" : "ms-4" '>
                {{ submitOtpErrorMessage }}
              </p>
            </div>
          </div>

          <div class="btn-div mt-4 mb-3">
            <button type="button" class="submit-btn bg-orgclr mb-3" [disabled]="!otpValue" (click)="submitOTP()">
              {{ "LOGIN.SUBMIT" | translate }}
            </button>
            <button type="button" class="cancel-btn bg-cancelbtn" (click)="closeOEmailCance()">
              {{ "LOGIN.CANCEL" | translate }}
            </button>
          </div>


          <div class="d-flex mt-2 align-items-center justify-content-center mb-3 notOtpDiv" *ngIf="!timeOver && isOTP">
            <span>{{ "LOGIN.DIDNTRECEIVEOTP" | translate }}</span>
            <button type="button" class="border-0 bg-white resend-Otp cursor-pointer shadow-none outline-none p-0 ms-2"
              (click)="resendOtp()">
              <u>{{ "LOGIN.RESEND" | translate }}</u>
            </button>
          </div>
        </div>
        <ng-container *ngIf="isOTP && timeOver">
          <div class="d-flex align-items-center justify-content-center mb-3">
            <small>
              {{ "RESENDOT.RESENDOTPIN" | translate }}
              {{ durationMinutes }}</small>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="isReset">
      <div class="modal-content resetpwd p-4 pb-5">

        <form [formGroup]="resetPwdForm" (ngSubmit)="forgotPassword()">
          <div class="">
            <div class="form-div">
              <div class="text-center my-3">
                <h5 class="mb-0">
                  <app-main-heading>
                    <span title> {{ "LOGIN.RESETPASSWORD" | translate }}</span>
                  </app-main-heading>
                </h5>
              </div>
              <div class="mb-3">
                <label for="newpassword" class="q-form-label">{{ "LOGIN.NEWPASSWORD" | translate }} </label><span
                  class="text-danger">*</span>
                <input autofocus="true" [type]="passwordReset" autocomplete="off" (keyup)="passwordVerify()"
                  class="form-control q-form-control pr-40" formControlName="password"
                  placeholder="{{ 'LOGIN.ENTERNEWPASSWORD' | translate }}" />
                <div class="showpwdIcon" (click)="onClick('newPwd')">
                  <img [src]="'IMAGES.HIDEPWD'|translate" alt="" *ngIf="
                      !newPassword && resetPwdForm.value.password?.length != 0
                    " class="cursor-pointer" />
                  <img [src]="'IMAGES.SHOWPWD'|translate" alt="" *ngIf="
                      newPassword && resetPwdForm.value.password?.length != 0
                    " class="cursor-pointer" />
                </div>
                <div class="mw-340">
                  <p class="errMessage" *ngIf="resetPwdForm.controls['password'].errors">
                    {{ "LOGIN.PASSWORDSPECIALCHARACTER" | translate }}<br />
                  </p>
                </div>
              </div>

              <div>
                <label for="confirmpassword" class="q-form-label">{{ "LOGIN.CONFIRMPASSWORD" | translate }}
                </label><span class="text-danger">*</span>
                <input [type]="passwords" autocomplete="off" class="form-control q-form-control pr-40"
                  (keyup)="onFocusOut()" formControlName="newPassword"
                  placeholder="{{ 'LOGIN.REENTERNEWPASS' | translate }}" />
                <div class="showpwdIcon" (click)="onClick('confPwd')">
                  <img [src]="'IMAGES.HIDEPWD'|translate" alt="" *ngIf="
                      !confPassword && resetPwdForm.value.newPassword?.length != 0
                    " class="cursor-pointer" />
                  <img [src]="'IMAGES.SHOWPWD'|translate" alt="" *ngIf="
                      confPassword && resetPwdForm.value.newPassword?.length != 0
                    " class="cursor-pointer" />
                </div>
                <ng-container *ngIf="pwdNotMatch">
                  <p class="errMessage">
                    {{ "LOGIN.PASSWORDDOESNOTMATCH" | translate }}
                  </p>
                </ng-container>
              </div>
            </div>

            <div class="pwd-criteria mt-3">
              <div class="fw-bold">
                {{ "LOGIN.PASSWORDCRITERIA" | translate }}
              </div>
              <div>1. {{ "LOGIN.PASSWORDCONTAINS" | translate }}</div>
              <div>2. {{ "LOGIN.PASSWORDSPECIALCHARACTER" | translate }}</div>
            </div>

            <div class="btn-div mt-3">
              <button type="submit" [disabled]="resetPwdForm.invalid || pwdNotMatch" [ngClass]="
                  resetPwdForm.invalid || pwdNotMatch
                    ? 'q-invalid-button mb-3'
                    : 'submit-btn bg-orgclr mb-3'
                ">
                {{ "LOGIN.SUBMIT" | translate }}
              </button>
              <button type="button" class="cancel-btn bg-cancelbtn" (click)="closeResetPassord()">
                {{ "LOGIN.CANCEL" | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </ng-container>

  </div>
</div>